/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum GPCTransactionType {
    Authorization = 'AUTHORIZATION',
    Purchase = 'PURCHASE',
    Capture = 'CAPTURE',
    Refund = 'REFUND',
    Void = 'VOID',
    Reversal = 'REVERSAL',
    Verification = 'VERIFICATION'
}

export function GPCTransactionTypeFromJSON(json: any): GPCTransactionType {
    return GPCTransactionTypeFromJSONTyped(json, false);
}

export function GPCTransactionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GPCTransactionType {
    return json as GPCTransactionType;
}

export function GPCTransactionTypeToJSON(value?: GPCTransactionType | null): any {
    return value as any;
}

